export default {
  tags: {
    preferred: 'Preferred',
  },
};
